<template>
    <div class="container">
        <div class='header'>
            <img src="/img/shuiyi/logo1.png" class='logo' alt="">
            <img src="/img/shuiyi/logo3.png" class='logothree' alt="">
        </div>
        <div class='btnWarp'>
            <div class='save' @click='savepic'>
                <p class='savetext'>长按我保存完整图片</p>
            </div>
            <img src="/img/shuiyi/arrow.png" class='arrow' alt="">
        </div>
        <div class='maincontent'>
            <div class="swiper-container">
                <div class="swiper-wrapper">
                    <div v-for='(i,index) in arrItem' :key='index' class="swiper-slide">
                        <div class="iSlide">
                            <img class="img" :src="i.imgUrl">
                        </div>
                    </div>
                </div>
                <div class="swiper-pagination"></div>
                <img :src="userInfo.portraitUrl" class='usericon' alt="">
                <div class='tips'>
                    <p class='name'>{{userInfo.nickName}}</p>
                    <p class='name'>喜欢自己，</p>
                    <p class='name'>你才是你今生的唯一。</p>
                </div>
            </div>
            <div class="bottom-wrap">
                <div class='ercode'>
                    <a href="https://weidian.com/item.html?itemID=2704608513&spider_token=ace8&ifr=itemdetail&state=H5WXshareOld&distributorId=737929790&share_relation=c20ec5c63d9bc5cc_737929790_1&wfr=h5direct_wxh5&from=singlemessage&isappinstalled=0">
                        <img src="/img/shuiyi/dianwo.png" class='dianj' alt="" @click='goweishop'>
                    </a>
                    <img src="/img/shuiyi/kefuerwei.jpg" class='erweima' alt="">
                    <div class='textwarp' @click='shibie'>
                        <p class='name'>长按识别二维码添加客服号</p>
                        <p class='name'>回复“梅花”即可获得文创品VIP折扣</p>
                        <div class='startWarp' @click='goindex'>
                            <img src="/img/shuiyi/restart.png" class='restart' alt="">
                            <p class='restarttext'>回放</p>
                        </div>
                    </div>
                </div>
            </div>
            <div style='width:100%;height:5%'></div>
        </div>
        <div class='savePic' ref='temp' v-bind:style="{background: 'url(' + currentimg + ') 0 0/100% 100% no-repeat'}">
            <div class='tempwarp'>
                <div class='saveheader'>
                    <img src="/img/shuiyi/sharelogo.png" class='savelogo' alt="">
                    <img src="/img/shuiyi/logo3.png" class='savelogothree' alt="">
                </div>
                <div class='picWarp'>
                    <div class='imgwarp'></div>
                    <div class='footer'>
                        <img :src="userInfo.portraitUrl" class='usericon' alt="" v-if='userInfo.portraitUrl'>
                        <div class='tips'>
                            <p class='name'>{{userInfo.nickName}}</p>
                            <p class='name'>喜欢自己，</p>
                            <p class='name'>你才是你今生的唯一。</p>
                            <img :src="erweicode" class='erweima2' alt="">
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <audio
            src="/media/shuiyi.mp3"
            loop
            autoplay
            preload="auto"
            v-if='audioPlayerShow'
            ref="music">
        </audio>
        <img :src="this.base64" alt="" class="pic_template">
    </div>
</template>

<script>
import Swiper from 'swiper';
import html2canvas from 'html2canvas';

export default {
    data() {
        return {
            arrItem: [
                {
                    name: 'swiperSlide51',
                    imgUrl: '/img/shuiyi/shuiyi3.png',
                    bgcurl: '/img/shuiyi/baocun3.jpg'
                },
                {
                    name: 'swiperSlide51',
                    imgUrl: 'http://wwj.jijiagames.com/web/act/20190307/weiye2.png',
                    bgcurl: '/img/shuiyi/baocun2.jpg'
                },
                {
                    name: 'swiperSlide51',
                    imgUrl: '/img/shuiyi/shuiyi4.png',
                    bgcurl: '/img/shuiyi/baocun4.jpg'
                },
                {
                    name: 'swiperSlide1',
                    imgUrl: 'http://wwj.jijiagames.com/web/act/20190307/weiye1.png',
                    bgcurl: '/img/shuiyi/baocun1.png'
                }
            ],
            base64: '',
            activeIndex: 0,
            currentimg: '/img/shuiyi/baocun3.jpg',
            audioPlayerShow: true,
            erweicode: '/img/shuiyi/h5erwei.png'
        };
    },
    methods: {
        goindex() {
            this.$emit('goindex');
            this.$refs.music.pause();
        },
        pinIndex(data) {
            this.currentimg = this.arrItem[data].bgcurl;
            html2canvas(this.$refs.temp, {
                scale: 1,
                logging: false,
                useCORS: true
            }).then(c => {
                this.base64 = c.toDataURL('image/png', 1);
            });
        },
        savepic() {
            /* eslint-disable-next-line */
            window._hmt.push(['_trackEvent', '市场3.8节-长按保存图片', '长按保存图片点击数量', window.location.href]);
        },
        goweishop() {
            /* eslint-disable-next-line */
            window._hmt.push(['_trackEvent', '市场3.8节-跳转微店', '跳转微店点击数量', window.location.href]);
        },
        shibie() {
            /* eslint-disable-next-line */
            window._hmt.push(['_trackEvent', '市场3.8节-识别二维码', '识别二维码点击数量', window.location.href]);
        }
    },
    mounted() {
        switch (this.$route.params.source) {
            case 'kzl':
                this.erweicode = '/img/shuiyi/kzlcode.png';
                /* eslint-disable-next-line */
                window._hmt.push(['_trackEvent', '市场3.8节-kzl渠道', 'kzl渠道H5点击量 ', window.location.href]);
                break;
            default:
                /* eslint-disable-next-line */
                window._hmt.push(['_trackEvent', '市场3.8节-自有渠道', '自有渠道H5点击量 ', window.location.href]);
                this.erweicode = '/img/shuiyi/h5erwei.png';
                break;
        }
        const that = this;
        // --创建触摸监听，当浏览器打开页面时，触摸屏幕触发事件，进行音频播放
        document.addEventListener('touchstart', () => {
            function audioAutoPlay() {
                if (that.$refs.music) {
                    that.$refs.music.play();
                }
            }
            audioAutoPlay();
        });
        /* eslint-disable no-new */
        new Swiper('.swiper-container', {
            pagination: {
                el: '.swiper-pagination'
            },
            on: {
                slideChangeTransitionStart() {
                    that.pinIndex(this.activeIndex);
                }
            }
        });
        html2canvas(this.$refs.temp, {
            scale: 1,
            logging: false,
            useCORS: true
        }).then(c => {
            this.base64 = c.toDataURL('image/png', 1);
        });
    },
    computed: {
        userInfo() {
            return this.$store.state.system.userInfo || {};
        }
    },
    created() {
    }
};
</script>

<style lang="stylus" scoped>
@import "../../../../node_modules/swiper/dist/css/swiper.min.css";
.container
    width 100%
    height 100%
    display flex
    flex-direction column
    background-color #e6eeec
    .header
        width 100%
        position relative
        display flex
        flex-direction row
        align-items center
        .logo
            width 0.57rem
            height 0.48rem
            position absolute
            top 0.05rem
            left 0.3rem
        .logothree
            width 0.45rem
            height 0.45rem
            position absolute
            top 0.09rem
            left 1.1rem
    .maincontent
        width 6.86rem
        margin 0 0.32rem
        flex 1
        position relative
        overflow hidden
        z-index 10000
        .swiper-container
            width 100%
            height 60%
            border 0.05rem solid #fff
            .usericon
                width 0.67rem
                height 0.67rem
                position absolute
                bottom 1.8rem
                right 5.84rem
                left 0.35rem
                z-index 10000
            .tips
                position absolute
                bottom 0.6rem
                left 0.31rem
                z-index 10000
                .name
                    font-size 0.25rem
                    line-height 0.35rem
                    color #fff
            .img
                width 100%
                height 100%
        .bottom-wrap
            size 100% 35%
            background-color #fff
            border 0.05rem solid #fff
            border-top none
            .ercode
                height 100%
                display flex
                flex-direction column
                padding-left 0.4rem
                padding-top 0.2rem
                -webkit-tap-highlight-color rgba(0,0,0,0)
                -webkit-tap-highlight-color transparent
                .dianj
                    width 3.46rem
                    height 1.06rem
                .erweima
                    width 1.07rem
                    height 1.07rem
                .textwarp
                    flex 1
                    display flex
                    flex-direction column
                    align-items flex-start
                    justify-content center
                    position relative
                    .name
                        font-size 0.25rem
                        line-height 0.35rem
                        color #848484
                    .startWarp
                        position absolute
                        right 0.3rem
                        bottom 0.5rem
                        .restart
                            width 0.63rem
                            height 0.64rem
                            margin-bottom -0.2rem
                        .restarttext
                            font-size 0.27rem
                            color #7f7e7e
    .savePic
        size 750px 1334px
        position fixed
        top 100rem
        left 0
        display flex
        flex-direction column
        align-items center
        justify-content center
        .tempwarp
            width 95%
            margin 0.1rem 0.3rem
            flex 1
            border 0.02rem solid #ccc
            display flex
            flex-direction column
            .saveheader
                width 7.09rem
                .savelogo
                    width 0.8rem
                    height 0.68rem
                    margin 0.44rem 0.23rem 0 0.21rem
                .savelogothree
                    width 0.7rem
                    height 0.7rem
            .picWarp
                width 100%
                flex 1
                .imgwarp
                    width 100%
                    height 75%
                .footer
                    width 100%
                    height 25%
                    padding-left 0.4rem
                    display flex
                    flex-direction column
                    justify-content space-around
                    align-items flex-start
                    position relative
                    .usericon
                        width 0.67rem
                        height 0.67rem
                        margin-top 0.2rem
                    .tips
                        .name
                            font-size 0.25rem
                            line-height 0.35rem
                            color #fff
                    .erweima2
                        width 1.06rem
                        height 1.06rem
                        position absolute
                        right 0.2rem
                        bottom 0.5rem
    .pic_template
        position fixed
        size 100%
        top 0
        left 0
        z-index 1000
        opacity 0
.btnWarp
    width 100%
    display flex
    height 1.4rem
    flex-direction row
    justify-content flex-end
    padding-right 0.3rem
    position relative
    top 3%
    right 22%
    .save
        width 3.6rem
        height 0.8rem
        float right
        background url('/img/shuiyi/bgc.png') 0 0/100% 100% no-repeat
        z-index 1000
        display flex
        flex-direction row
        align-items center
        justify-content center
        .savetext
            font-size 0.3rem
            color yellow
    .arrow
        width 0.96rem
        height 1.2rem
        position absolute
        right 1.5rem
        top 0.55rem
        z-index 100000
</style>
